import React, { useEffect, useState } from "react";
import { fetchEvents } from "../api";
import { Link } from "react-router-dom";

const AdminEvents = () => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        fetchEvents().then(setEvents);
    }, []);

    return (
        <div>
            <h1>管理者用イベント一覧</h1>
            <ul>
                {events.map(event => (
                    <li key={event.eventId}>
                        <Link to={`/events/${event.eventId}`}>{event.eventName} - {event.eventDate}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdminEvents;
